import {useState} from "react";
import {downloadFilesForTicket} from "../../services/Administrative/ticketsService";

export const useDownloadTicketFiles = () => {

    const [filesToDownload, setFilesToDownload] = useState<string []>([]);

    const getFiles = async (ticketUniqueCode: string) => {
        try {
            const response = await downloadFilesForTicket(ticketUniqueCode);
            setFilesToDownload(response.files)
            return response;
        } catch (error) {
            console.error('Error downloading files for ticket');
            throw error;
        }
    };

    return {filesToDownload, getFiles};
};
